/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

export const itemPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
});

itemPropType.items = PropTypes.arrayOf(itemPropType);
